import { Capabilities } from "src/hooks/useCapabilities/types";

export const canAccessSettingsPage = (capabilities: Capabilities) =>
  capabilities.usersPermissions.canAccess ||
  capabilities.connections.canAccess ||
  capabilities.apiKeys.canAccess ||
  capabilities.aiUsageLimits.canAccess;
